import * as constants from 'actions/constants'
import { EntryType } from 'actions/general'
import { arrayRemove, removeEntriesFromArrayById, removeEntryFromArrayById } from 'helpers/array'
import { Community } from 'types/community'
import { EntryDateIndex } from './postReducer'
import { entryListToIndexes, entryListToMap } from 'helpers/general'
import { isDev } from "app/general"

const defaultState: CommunityReducer = {
  communities: new Map(),
  entryDateIndex: [],
  loading: false
}

export interface CommunityReducer {
  communities: Map<string, Community>
  entryDateIndex: EntryDateIndex[]
  loading: boolean
}
let communitiesObject: Map<string, Community> = new Map()
let entryDateIndex: EntryDateIndex[] = []
let newDateIndex = [];

export default function community(state = defaultState, action: any) {
  switch (action.type) {
    case constants.GET_LATEST_COMMUNITIES_TRY:
      return Object.assign({}, state, {
        loading: true
      })

    case constants.GET_LATEST_COMMUNITIES_ERROR:
      return Object.assign({}, state, {
        loading: false
      })

    case constants.GET_LATEST_COMMUNITIES_RESPONSE:
      if (action.response.success) {
        communitiesObject = state.communities instanceof Map ? new Map(state.communities) : new Map()
        entryDateIndex = state.entryDateIndex
        return Object.assign({}, state, {
          communities: entryListToMap<Community>(action.response.entries, communitiesObject),
          entryDateIndex: entryListToIndexes<Community>(action.response.entries, [...state.entryDateIndex]),
          loading: false
        })
      } else {
        return Object.assign({}, state, {
          loading: false
        })
      }

    case constants.GET_MY_COMMUNITIES_RESPONSE:
      if (action.response.success) {
        communitiesObject = state.communities instanceof Map ? new Map(state.communities) : new Map()
        entryDateIndex = state.entryDateIndex
        return Object.assign({}, state, {
          communities: entryListToMap<Community>(action.response.entries, communitiesObject),
          entryDateIndex: entryListToIndexes<Community>(action.response.entries, [...state.entryDateIndex])
        })
      }
      return state

    case constants.DELETE_ENTRY_RESPONSE:
      if (action.entryType !== EntryType.COMMUNITY) return state
      if (!action.response.success) return state

      entryDateIndex = removeEntryFromArrayById(state.entryDateIndex, action.entryId);
      communitiesObject = new Map(state.communities)
      communitiesObject.delete(action.entryId);
      return Object.assign({}, state, { communities: communitiesObject, entryDateIndex: entryDateIndex })

    case constants.GET_COMMUNITY_RESPONSE:
      if (action.response.success) {
        communitiesObject = state.communities instanceof Map ? new Map(state.communities) : new Map()
        return Object.assign({}, state, {
          communities: entryListToMap<Community>([action.response.entry], communitiesObject),
          entryDateIndex: entryListToIndexes<Community>([action.response.x])
        })
      }
      if (action.response.status === 404) {
        if (!state.communities.has(action.entryId)) return state

        entryDateIndex = removeEntryFromArrayById(entryDateIndex, action.entryId);
        communitiesObject = new Map(state.communities)
        communitiesObject.delete(action.entryId);
        return Object.assign({}, state, { communities: communitiesObject, entryDateIndex: entryDateIndex })
      }
      return state;


    case constants.CREATE_IMAGE_COMMUNITY_RESPONSE:
      if (!action.response.success) return state;
      isDev && console.log("CREATE_IMAGE_COMMUNITY_RESPONSE", action.response.entry)
      newDateIndex = entryListToIndexes(action.response.x ? [action.response.x] : []);
      communitiesObject = new Map(state.communities)
      communitiesObject.set(action.response.entry.id, action.response.entry)

      return Object.assign({}, state, {
        communities: communitiesObject,
        entryDateIndex: newDateIndex
      })


    case constants.CLEAR_OLD_DATA:
      if (action.force && action.entryType === EntryType.COMMUNITY) return defaultState
      if (state.entryDateIndex.length < 30) return state
      const newEntryDateIndex = state.entryDateIndex.sort((a, b) => b.date - a.date).slice(0, 30)
      communitiesObject = new Map(state.communities);
      for (const entryIndex of newEntryDateIndex) {
        communitiesObject.delete(entryIndex.entryId)
      }
      return Object.assign({}, state, { communities: communitiesObject, entryDateIndex: newEntryDateIndex })

    case constants.DELETE_COMMUNITY_RESPONSE:
      if (!action.response.success) return state;

      entryDateIndex = [...state.entryDateIndex]
      entryDateIndex = removeEntryFromArrayById(entryDateIndex, action.entryId);
      communitiesObject = new Map(state.communities)
      communitiesObject.delete(action.entryId);
      return Object.assign({}, state, { communities: communitiesObject, entryDateIndex: entryDateIndex })



    // case constants.CLEAR_OLD_DATA:return
    //   const MonthInMilliseconds3 = 2592000000 * 3
    //   const oldDataIndex = state.entryDateIndex.filter((e: EntryDateIndex) => new Date().getTime() - e.date > MonthInMilliseconds3)
    //   const oldData = oldDataIndex.map((e: EntryDateIndex) => e.entryId)
    //   entryDateIndex = removeEntriesFromArrayById(state.entryDateIndex, oldData);
    //   communitiesObject = Object.assign({}, state.communities);
    //   for (const entryId of oldData) {
    //     communitiesObject.delete(entryId)
    //   }
    //   return Object.assign({}, state, { communities: communitiesObject, entryDateIndex: entryDateIndex })

    case constants.JOIN_COMMUNITY_RESPONSE:
      if (action.response.success) {
        communitiesObject = state.communities instanceof Map ? new Map(state.communities) : new Map()
        const c = communitiesObject.get(action.entryId);
        if (!c) return;
        if (!c.joinsIds) c.joinsIds = []
        if (action.newState) {
          c.joinsIds.push(action.uid)
        }
        else {
          c.joinsIds = arrayRemove(c.joinsIds, action.uid)
        }

        return Object.assign({}, state, {
          communities: communitiesObject
        })
      }

    case constants.LOGOUT_RESPONSE:
      return defaultState

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      return state
  }
}
const processCommunity = (value: any) => {
  //TODO NEEDS WORK 
  value.startDate = new Date(parseInt(value.startDate))
  value.endDate = new Date(parseInt(value.endDate))
  value.organiserName = value.profile?.name
  value.organiserImage = value.profile?.image
  // value.image = value.imageDownloadLink
  return value

}

const mergeCommunityLists = (listOne: Community[], listTwo: Community[]) => {
  //PRIORITY TO ListOne
  const listTOAddToOne = listTwo.filter((e2: Community) => {
    if (listOne.filter((e1: Community) => e1.id === e2.id).length > 0) return true
    return false
  })
  listOne.concat(listTOAddToOne)
  return listOne
}

// const organiseCommunitiesFromResponse = (communitiesResponse: any[]) => {
//   if (!communitiesResponse) return []
//   let communityList = []
//   for (const [key, value] of Object.entries(communitiesResponse) as any) {
//     if (key === null || value === null) break;
//     const post: Post = {
//       id: key,
//       ...value
//     }
//     allPosts.push(post)
//   }
//   for (const value of communitiesResponse) {
//     const community: Community = processCommunity(value)
//     communityList.push(community)
//   }

//   communityList = communityList.reverse()

//   return communityList
// }

// const processPosts = (postsResponse: any): Post[] => {
//    isDev && console.log({ postsResponse })
//   let allPosts = []
//   if (postsResponse)
//     for (const [key, value] of Object.entries(postsResponse).reverse() as any) {
//       if (key === null || value === null) break;
//       const post: Post = {
//         id: key,
//         ...value
//       }
//       allPosts.push(post)
//     }
//   return allPosts
// }

